import * as React from 'react';

import { IconSvgProps } from '@/types';

export const BackButton: React.FC<IconSvgProps> = ({
  width = 31,
  height = 51,
}) => (
  <svg fill="none" height={height} viewBox="0 0 31 51" width={width}>
    <path
      clipRule="evenodd"
      d="M28.8158 6.9913C30.4504 5.50528 30.5709 2.97548 29.0849 1.34085C27.5989 -0.293779 25.0691 -0.414245 23.4344 1.07178L1.34085 21.1569C0.164033 22.2267 -0.227997 23.8375 0.199213 25.2658C-0.19897 26.624 0.13761 28.1519 1.20895 29.2232L21.0186 49.0328C22.5806 50.5949 25.1133 50.5949 26.6754 49.0328C28.2375 47.4707 28.2375 44.938 26.6754 43.3759L8.63603 25.3366L28.8158 6.9913Z"
      fill="black"
      fillRule="evenodd"
    />
  </svg>
);
